import { Icon, TableCell, TableRow, Typography } from '@mui/material'
import React from 'react'

import { SchemaWatemplate } from '@/__generated/es-api'
import IconText from '@/app/component/layout/icon-text'
import { extractWhatsappContent } from '@/app/module/common/whatsapp/whatsapp-content'
import WhatsappRowContent from '@/app/module/logs/component/whatsapp-row-content'
import { formatDateTime } from '@/app/service/util'
import { TWhatsappContent } from '@/app/types'

import RowActions from './row-actions'
import { getCategoryLabel } from './util'

type Props = {
  template: SchemaWatemplate
}

const Row: React.FC<Props> = ({ template }) => {
  const waContent = React.useMemo(
    () => extractWhatsappContent(template.content as TWhatsappContent),
    [template.content],
  )

  return (
    <TableRow key={template.id} hover>
      <TableCell>
        <Typography variant="body2" component="div">
          {getCategoryLabel(template.category)}
        </Typography>
      </TableCell>
      <TableCell sx={{ py: 1 }}>
        <WhatsappRowContent variant="inherit" waContent={waContent} />
      </TableCell>
      <TableCell>{renderStatus(template)}</TableCell>
      <TableCell>{formatDateTime(template.created)}</TableCell>
      <TableCell>
        <RowActions template={template} />
      </TableCell>
    </TableRow>
  )
}

const renderStatus = (template: SchemaWatemplate) => {
  if (!template.register) {
    return (
      <IconText>
        <Icon color="disabled">cancel</Icon>
        <Typography>Not registered</Typography>
      </IconText>
    )
  }
  if (template.pending) {
    return (
      <IconText>
        <Icon color="warning">schedule</Icon>
        <Typography>Pending</Typography>
      </IconText>
    )
  }
  if (!template.approved) {
    return (
      <IconText>
        <Icon color="error">block</Icon>
        <Typography>Rejected</Typography>
      </IconText>
    )
  }
  return (
    <IconText>
      <Icon color="success">check_circle</Icon>
      <Typography>Approved</Typography>
    </IconText>
  )
}

export default Row
